import React from 'react';
import { ensureSecureUrl } from '../../utils/urlHelper';

const ImageBlockDisplay = ({ content }) => {
    if (!content || !content.imageUrl) return null;

    return (
        <div className="p-6 md:p-8 rounded-xl border border-outlineVariant bg-surface text-surface-on">
            {content.title && (
                <h3 className="text-headline-small font-bold mb-6 text-surface-on">
                    {content.title}
                </h3>
            )}
            <div className="rounded-xl overflow-hidden shadow-elevation-2">
                <img
                    src={ensureSecureUrl(content.imageUrl)}
                    alt={content.title || 'Profil-Bild'}
                    className="w-full h-auto object-cover block"
                    loading="lazy"
                />
            </div>
            {content.caption && (
                <p className="mt-4 text-body-medium text-surface-onVariant italic text-center">
                    {content.caption}
                </p>
            )}
        </div>
    );
};

export default ImageBlockDisplay;
